export default class Header {
  constructor($module) {
    this.$module = $module;

    const navbarMenu = document.getElementById("navbar");
    const burgerMenu = document.getElementById("burger");
    const cleanSearchIcon = document.querySelector(
      ".bc-header__search-close .bc-icon"
    );
    const cleanSearchIconMobile = document.querySelector(
      ".bc-header__search-close--mobile .bc-icon"
    );
    const linkWithChildren = document.querySelectorAll(
      ".bc-header__quick-nav-menu-item-has-children2"
    );

    const userAccount = document.getElementById("user-account");
    const userAccountList = document.querySelector(".bc-header__my-account");
    const backBtn = document.querySelectorAll(".bc-header__back-to-menu");
    const header = document.querySelector(".bc-header");
    const searchInput = document.querySelector(".bc-header__search_input");
    const searchInputMobile = document.querySelector(
      ".bc-header__search_input--mobile"
    );

    const iconCleanText = document.querySelector(".bc-header__search-close");
    const iconCleanTextMobile = document.querySelector(
      ".bc-header__search-close--mobile"
    );
    const textSearch = document.querySelector(".bc-header__navbar-search");
    let headerSearch = document.getElementsByClassName("bc-header")[0];
    let activeDashboard = document.getElementsByClassName(
      "bc-header__my-account"
    )[0];
    let activeDashboardDiv = document.getElementsByClassName(
      "bc-header__logged-in"
    )[0];

    searchInput.addEventListener("keyup", showIcon);
    searchInputMobile.addEventListener("keyup", showIconMobile);
    burgerMenu.addEventListener("click", toggleMenu);

    if (userAccount) {
      userAccount.addEventListener("click", toggleUserAccount);
    }

    function removeMenu(e) {
      if (
        !e.target.closest(".bc-header__quick-nav-menu-item-sub-menu") ||
        e.target.closest(".bc-header__quick-nav-menu__title")
      ) {
        document.removeEventListener("click", removeMenu);
        let activeContainer = document.querySelector(".active-container");

        if (activeContainer?.classList?.contains("active-container")) {
          activeContainer.classList.remove("active-container");
        }
      }
    }

    function removeSearch(e) {
      if (window.innerWidth > 992) {
        if (
          !e.target.closest(".bc-header__navbar-search") &&
          !e.target.closest(".bc-header__search-desktop")
        ) {
          document.removeEventListener("click", removeSearch);
          let headerSearch = document.getElementsByClassName("bc-header")[0];
          if (
            headerSearch?.classList?.contains("bc-header__search-open") &&
            textSearch?.classList?.contains("transparent")
          ) {
            headerSearch.classList.remove("bc-header__search-open");
            textSearch.classList.remove("transparent");
          }
        }
      }
    }

    cleanSearchIcon.addEventListener("click", cleanInput);
    cleanSearchIconMobile.addEventListener("click", cleanInputMobile);

    function showIcon() {
      if ($(this).val().length >= 1) {
        iconCleanText.classList.add("active-clean");
      } else {
        iconCleanText.classList.remove("active-clean");
      }
    }
    function showIconMobile() {
      if ($(this).val().length >= 1) {
        iconCleanTextMobile.classList.add("active-clean");
      } else {
        iconCleanTextMobile.classList.remove("active-clean");
      }
    }

    keyPress();
    function keyPress() {
      document.onkeydown = function (evt) {
        if (evt.key === "Escape") {
          let headerSearch = document.getElementsByClassName("bc-header")[0];
          if (
            headerSearch?.classList?.contains("bc-header__search-open") &&
            textSearch?.classList?.contains("transparent")
          ) {
            headerSearch.classList.remove("bc-header__search-open");
            textSearch.classList.remove("transparent");
          }
        }
      };
    }
    keyPress();

    function toggleMenu() {
      navbarMenu.classList.toggle("active-burger");
      this.classList.toggle("active-burger");
      header.classList.toggle("active-burger");
      let elementWithActiveClassMobile = document.querySelectorAll(
        ".open-mobile"
      );
      elementWithActiveClassMobile.forEach(function (element) {
        element.classList.remove("open-mobile");
      });
    }
    function toggleUserAccount() {
      userAccountList.classList.toggle("active-dashboard");
      this.parentElement.classList.toggle("active-dashboard");
    }

    function collapseSubMenu() {
      const $coll = document.querySelectorAll(`[data*="data-toggle"]`);
      let $i;
      for ($i = 0; $i < $coll.length; $i++) {
        $coll[$i].addEventListener("click", function (e) {
          this.parentElement.parentElement.classList.toggle("open-mobile");
          this.parentElement.parentElement.parentElement.classList.toggle(
            "open-mobile"
          );
          const content = this.parentElement.nextElementSibling;
          content?.classList?.toggle("open-mobile");
        });
      }
    }

    // }
    //back btn
    backBtn.forEach(function (activeMenu) {
      activeMenu.addEventListener("click", function (e) {
        e.preventDefault();
        this.parentElement.parentElement.classList.remove("open-mobile");
        this.parentElement.classList.remove("open-mobile");
        this.parentElement?.parentElement?.parentElement?.classList?.remove(
          "open-mobile"
        );
      });
    });

    //add active class to desktop version menu
    linkWithChildren.forEach(function (activeMenu) {
      activeMenu.addEventListener("click", function (e) {
        e.stopPropagation();
        headerSearch &&
          headerSearch?.classList?.remove("bc-header__search-open");
        textSearch && textSearch?.classList?.remove("transparent");

        let parentElement = this.parentElement;
        let elementWithActiveClass = parentElement.querySelectorAll(
          ".active-container"
        );
        if (
          activeDashboard?.classList?.contains("active-dashboard") &&
          activeDashboardDiv?.classList?.contains("active-dashboard")
        ) {
          activeDashboard.classList.remove("active-dashboard");
          activeDashboardDiv.classList.remove("active-dashboard");
        }
        if (!elementWithActiveClass.length) {
          document.addEventListener("click", removeMenu);
          activeDashboard &&
            activeDashboardDiv?.classList?.remove("active-dashboard");
        }
        if (
          e.target.closest(".bc-header__quick-nav-menu__title") &&
          e.target.closest(".active-container")
        ) {
          removeMenu(e);
        } else {
          elementWithActiveClass.forEach(function (element) {
            element.classList.remove("active-container");
          });
          this.classList.add("active-container");
        }
      });
    });

    // Fixed Resize Screen Function
    window.addEventListener("resize", () => {
      if (this.innerWidth > 1024) {
        // If navbarMenu is Open, then Close It
        if (navbarMenu.classList.contains("active")) {
          toggleMenu();
        }
      }
    });
    collapseSubMenu();

    const $search_coll = document.querySelectorAll(
      `[data*="data-toggle-search"]`
    );
    let $i;
    for ($i = 0; $i < $search_coll.length; $i++) {
      $search_coll[$i].addEventListener("click", function () {
        toggleSearch();
      });
    }

    function toggleSearch() {
      let headerSearch = document.getElementsByClassName("bc-header")[0];
      document
        .getElementsByClassName("bc-header")[0]
        .classList.toggle("bc-header__search-open");
      textSearch.classList.toggle("transparent");
      document.getElementsByClassName("bc-header__search_input")[0]
        .offsetParent === null
        ? document.getElementsByClassName("bc-header__search_input")[1].focus()
        : document.getElementsByClassName("bc-header__search_input")[0].focus();
      let activeDashboard = document.getElementsByClassName(
        "bc-header__my-account"
      )[0];
      let activeDashboardDiv = document.getElementsByClassName(
        "bc-header__logged-in"
      )[0];
      if (
        activeDashboard?.classList?.contains("active-dashboard") &&
        activeDashboardDiv?.classList?.contains("active-dashboard")
      ) {
        activeDashboard.classList.remove("active-dashboard");
        activeDashboardDiv.classList.remove("active-dashboard");
      }
      if (
        textSearch.classList.contains("transparent") ||
        headerSearch?.classList?.contains("bc-header__search-open")
      ) {
        document.addEventListener("click", removeSearch);
      }
    }
    function cleanInput(target) {
      const inputValue = document.getElementById("search");
      inputValue.value = "";
      if ($(this).val().length >= 1) {
        iconCleanText.classList.add("active-clean");
      } else {
        iconCleanText.classList.remove("active-clean");
      }
    }
    function cleanInputMobile(target) {
      const inputValue = document.querySelector(
        ".bc-header__search_input--mobile"
      );
      inputValue.value = "";
      if ($(this).val().length >= 1) {
        iconCleanTextMobile.classList.add("active-clean");
      } else {
        iconCleanTextMobile.classList.remove("active-clean");
      }
    }
  }
}
